__turbopack_context__.v({
  "nav": "nav-component-module-scss-module__ienltG__nav",
  "nav__desktop-wrapper": "nav-component-module-scss-module__ienltG__nav__desktop-wrapper",
  "nav__mobile-wrapper": "nav-component-module-scss-module__ienltG__nav__mobile-wrapper",
  "nav__mobile-wrapper--active": "nav-component-module-scss-module__ienltG__nav__mobile-wrapper--active",
});
